import { HealthResolutionGroup } from './event-health-form-review.types';

export type EventHealthReviewLevel = 'form' | 'master-data' | 'full';

export function normalizeEventHealthReviewLevel(value: unknown): EventHealthReviewLevel {
  return value === 'form' || value === 'master-data' || value === 'full' ? value : 'full';
}

export function isResolutionIncluded(level: EventHealthReviewLevel, group: HealthResolutionGroup): boolean {
  if (group === 'automatic') return true;
  if (level === 'form') return group === 'form';
  if (level === 'master-data') return group === 'form' || group === 'master-data';
  return true;
}
